import { FormCheckBox, FormInput, useFormContext } from "@4uhub/lib4uhub";
import { Grid } from "@mui/material";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useWatch } from "react-hook-form";
import { TFormsForm } from "./formSchema";

interface IShowLinkFieldsProps {
  disabled?: boolean;
}

export const ShowLinkFields = ({ disabled = false }: IShowLinkFieldsProps) => {
  const { t } = useTranslation();
  const { control, setValue } = useFormContext<TFormsForm>();
  const translationPath = "page.evaluation.forms.";

  const typeForm = useWatch({
    name: "typeForm",
    control,
  });

  const showLinkOnEnd = useWatch({
    name: "showLinkOnEnd",
    control,
  });

  useEffect(() => {
    if (!showLinkOnEnd) {
      setValue("showLinkGreaterThen", undefined);
      setValue("showLinkLink", undefined);
      setValue("showLinkDescription", undefined);
      setValue("showLinkButtonLabel", undefined);
    }
  }, [showLinkOnEnd, setValue]);

  if (typeForm?.code !== "1") return null;

  return (
    <>
      <Grid item xs={12}>
        <FormCheckBox
          name="showLinkOnEnd"
          label={`${t(translationPath + "show_link_on_end")}`}
          disabled={disabled}
        />
      </Grid>

      {showLinkOnEnd && (
        <>
          <Grid item xs={12} sm={3}>
            <FormInput
              size="small"
              name="showLinkGreaterThen"
              fullWidth
              type="number"
              disabled={disabled}
              label={t(translationPath + "show_link_greater_than")}
            />
          </Grid>

          <Grid item xs={12} sm={9}>
            <FormInput
              size="small"
              name="showLinkLink"
              fullWidth
              disabled={disabled}
              label={t(translationPath + "show_link_link")}
            />
          </Grid>

          <Grid item xs={12}>
            <FormInput
              size="small"
              name="showLinkDescription"
              fullWidth
              label={t(translationPath + "show_link_description")}
              multiline
              minRows={3}
              disabled={disabled}
            />
          </Grid>

          <Grid item xs={12} sm={4}>
            <FormInput
              size="small"
              name="showLinkButtonLabel"
              fullWidth
              disabled={disabled}
              label={t(translationPath + "show_link_button_label")}
            />
          </Grid>
        </>
      )}
    </>
  );
};
